export default __webpack_public_path__ + "static/media/follow.8c42bbab.png";